export default __webpack_public_path__ + "static/media/uniswapLogo.8a096431.png";